export default __webpack_public_path__ + "static/media/dashboard-banner.80555012.png";